import axios from 'axios';
import history from '../history';
import api from './apis';

import {
    LOADED,
    LOADEDING,
    SUCCESS_MESSAGE,
    ERROR_MESSAGE,
    VALIDATION_ERROR
} from './types';



export const createNewRole = (data) => async (dispatch) => {
    dispatch({type: LOADEDING});

    const object =  {
        "name" : data.name,
        "active": true,
        "account_management": data?.account_management,
        "book_management": data?.book_management,
        "app_management": data?.app_management,
        "author_management": data?.author_management,
        "banner_management": data?.banner_management,
        "notice_management": data?.notice_management,
        "publisher_management": data?.publisher_management,
        "store_management": data?.store_management,
        "support_management": data?.support_management,
        "b_user_management": data?.b_user_management,
        "user_management": data?.user_management,

    }
    
    try{
    
        const response = await api(localStorage.getItem("token")).post('/user-management/role/create', {...object});
        
        if(response.status === 201){
            dispatch({type: LOADED});
            dispatch({ type: SUCCESS_MESSAGE, payload: response.data.message });
            history.push('/roles');
        }

    }catch(err){
        /* =============Start========== */
          if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }
          dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
          dispatch({type: LOADED});
          /* ===========End============*/
    
    }
} 

export const getRoles = () => async (dispatch)=> {
    
    dispatch({type: LOADEDING});
    try{
        const response = await api(localStorage.getItem("token")).get('/user-management/role/all');
        
        dispatch({type: LOADED});
        return response?.data?.data
        // dispatch({type: GET_ROLES, payload: response.data.roles})
        
    }catch(err){
        /* =============Start========== */
          if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }
          dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
          dispatch({type: LOADED});
          /* ===========End============*/
    
}
}

export const getRoleById = (id) => async (dispatch)=> {
    
    dispatch({type: LOADEDING});
    try{
        const response = await api(localStorage.getItem("token")).get(`/user-management/role/${id}`);
        
        dispatch({type: LOADED});
        return response.data
        
    }catch(err){
        /* =============Start========== */
          if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }
          dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
          dispatch({type: LOADED});
          /* ===========End============*/
    
}
}

export const updateRole = (data, role) => async (dispatch) => {
    console.log(data);
    dispatch({type: LOADEDING});
    const object =  {
        "account_management": data?.account_management,
        "book_management": data?.book_management,
        "app_management": data?.app_management,
        "author_management": data?.author_management,
        "banner_management": data?.banner_management,
        "notice_management": data?.notice_management,
        "publisher_management": data?.publisher_management,
        "store_management": data?.store_management,
        "support_management": data?.support_management,
        "user_management": data?.user_management,
        "b_user_management": data?.b_user_management,
    }
    try{
        const response = await api(localStorage.getItem("token")).put(`/user-management/role/update?name=${role}`, {...object});
        
        if(response.status === 201){
            dispatch({ type: SUCCESS_MESSAGE, payload: "Role is updated Successfully" });
            dispatch({type: LOADED});
            history.push('/roles')
        }
        else{
           
        }

    }catch(err){
        /* =============Start========== */
          if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }
          dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
          dispatch({type: LOADED});
          /* ===========End============*/
    
    }
}


export const updateRoleAuth = (role, active) => async (dispatch) => {
    dispatch({type: LOADEDING});
    
    const object = {
      active:active,
    };
    dispatch({type: LOADED});
  
    try {
      const response = await api(localStorage.getItem("token")).put(`/user-management/role/status?name=${role}`,{ ...object });
  
      if (response.status === 201) {
        
      dispatch({type: LOADED});
      dispatch({type: SUCCESS_MESSAGE,payload: "Role authentication is updated succesfully"});
      
      return response.status
      }
    } catch (err) {
        /* =============Start========== */
          if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }
          dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
          dispatch({type: LOADED});
          /* ===========End============*/
    
    }
  };

export const deleteRole = (role, data) => async (dispatch) => {
dispatch({type: LOADEDING});


    try {
        const response = await api(localStorage.getItem("token")).delete(`/user-management/role/delete?name=${role}`);

        if (response.status === 201) {
        
        dispatch({type: LOADED});
        dispatch({type: SUCCESS_MESSAGE,payload: "User is deleted succesfully"});
        
        return response.status
        }
    } catch (err) {
        /* =============Start========== */
          if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }
          dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
          dispatch({type: LOADED});
          /* ===========End============*/
    
    }
};